export default "https://cdn-web.disco.co/default-experience-cloning-cover-5c964a97e0e27d16fb1874d7da33524c.png";